/**
 * Configuração centralizada de itens de submenu da navegação.
 * Altere APENAS este arquivo para adicionar/remover itens em qualquer submenu —
 * sidebar e header consomem estas listas automaticamente via v-for.
 *
 * Cada item: { label: string, to: string (rota vue-router), recurso?: string }
 * `recurso` marca itens liberados só para certas empresas (ver filtraItensMenu).
 */
import { produtosLiberado } from '@/constants/produtos';

/**
 * Remove do menu os itens de recursos restritos que a empresa ativa não tem liberados.
 * Usado pelo sidebar e pelo header (um único lugar para a regra).
 * @param {Array} itens  lista de itens de submenu
 * @param {string} cnpj  CNPJ da empresa ativa (store.getters.cnpjAtivo)
 */
export const filtraItensMenu = (itens, cnpj) =>
    itens.filter((item) => item.recurso !== 'produtos' || produtosLiberado(cnpj));

export const dashboardItems = [
    { label: 'Meu painel',           to: '/'       },
    { label: 'Novas oportunidades',   to: '/index2' },
];

export const minhasLicItems = [
    { label: 'Pregões',    to: '/apps/pregoes'  },
    { label: 'Calendário', to: '/apps/calendar' },
    { label: 'Produtos',   to: '/apps/produtos', recurso: 'produtos' },
    { label: 'Oportunidades de produtos', to: '/apps/produtos/oportunidades', recurso: 'produtos' },
];

export const lancesItems = [
    { label: 'ComprasNET',                   to: '/apps/lances/comprasnet' },
    { label: 'PCP',                          to: '/apps/lances/pcp'        },
    { label: 'BNC',                          to: '/apps/lances/bnc'        },
    { label: 'BLL',                          to: '/apps/lances/bll'        },
];

export const configItems = [
    { label: 'Central de Empresas', to: '/configs/central'     },
    { label: 'Logins de Portais', to: '/configs/loginsportal'  },
    { label: 'Alertas',           to: '/configs/alertasgeral'  },
    { label: 'Representados',     to: '/configs/representados' },
    { label: 'Documentos da Empresa', to: '/configs/documentos' },
    { label: 'Documentação Final', to: '/configs/documentacao' },
    { label: 'Celulares',         to: '/configs/celulares'     },
    { label: 'Logs de Sincronia', to: '/configs/logssincronia' },
];

export const usuarioItems = [
    { label: 'Perfil',       to: '/users/profile'      },
    { label: 'Troca senha',  to: '/users/troca-senha'  },
];
